(() => {
  const q = (selector, context = document) => context.querySelector(selector);
  const qa = (selector, context = document) => [...context.querySelectorAll(selector)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const overlay = q('[data-drawer-overlay]');
  const headerWrap = q('[data-header-wrap]');
  let lastDrawerTrigger = null;
  let drawerOpenTimer = 0;
  let drawerOpenFrame = 0;
  let pendingDrawerName = null;
  const drawerHideTimers = new WeakMap();

  function cancelDrawerHide(drawerElement) {
    const hideTimer = drawerHideTimers.get(drawerElement);
    if (hideTimer) window.clearTimeout(hideTimer);
    drawerHideTimers.delete(drawerElement);
  }

  function hideDrawerAfterClose(drawerElement, wasActive) {
    cancelDrawerHide(drawerElement);
    if (!wasActive || reduced) {
      drawerElement.hidden = true;
      return;
    }
    const hideTimer = window.setTimeout(() => {
      drawerHideTimers.delete(drawerElement);
      if (!drawerElement.classList.contains('is-open') && !drawerElement.classList.contains('is-preparing')) {
        drawerElement.hidden = true;
      }
    }, 520);
    drawerHideTimers.set(drawerElement, hideTimer);
  }

  const homeRibbon = q('[data-home-ribbon]');
  const homeHero = q('[data-home-hero]');
  if (homeRibbon) {
    let ribbonFrame = 0;
    const updateHomeRibbon = () => {
      const waitsForHero = homeRibbon.dataset.afterHero === 'true';
      const isVisible = !waitsForHero || !homeHero || homeHero.getBoundingClientRect().bottom <= 0;
      homeRibbon.classList.toggle('is-visible', isVisible);
      document.body.classList.toggle('wr-home-ribbon-visible', isVisible);
      if (isVisible && !homeRibbon.classList.contains('has-revealed')) {
        window.setTimeout(() => homeRibbon.classList.add('has-revealed'), reduced ? 0 : 1600);
      }
      ribbonFrame = 0;
    };
    updateHomeRibbon();
    window.addEventListener('scroll', () => {
      if (!ribbonFrame) ribbonFrame = requestAnimationFrame(updateHomeRibbon);
    }, { passive: true });
    window.addEventListener('resize', updateHomeRibbon, { passive: true });
  }

  if (headerWrap) {
    let lastScrollPosition = window.scrollY;
    let scrollFrame = 0;
    const productHeaderMode = document.body.classList.contains('template-product');
    const updateHeader = () => {
      const currentScrollPosition = Math.max(window.scrollY, 0);
      if (homeHero) {
        headerWrap.classList.toggle('is-on-dark', homeHero.getBoundingClientRect().bottom > 0);
      }
      if (!document.body.classList.contains('is-locked')) {
        headerWrap.classList.toggle('wr-topnav-hidden', currentScrollPosition > 42);
        if (currentScrollPosition < 18) {
          headerWrap.classList.remove('is-hidden', 'is-returned');
        } else if (productHeaderMode) {
          const productGallery = q('[data-product-gallery]');
          const galleryTop = productGallery ? productGallery.getBoundingClientRect().top + currentScrollPosition : 0;
          const returnedToFirstMedia = currentScrollPosition < lastScrollPosition && currentScrollPosition + innerHeight * .5 < galleryTop + innerHeight;
          headerWrap.classList.toggle('is-hidden', !returnedToFirstMedia);
          headerWrap.classList.toggle('is-returned', returnedToFirstMedia);
        } else if (currentScrollPosition > lastScrollPosition) {
          headerWrap.classList.add('is-hidden');
          headerWrap.classList.remove('is-returned');
        } else if (currentScrollPosition < lastScrollPosition) {
          headerWrap.classList.remove('is-hidden');
          headerWrap.classList.add('is-returned');
        }
      }
      lastScrollPosition = currentScrollPosition;
      scrollFrame = 0;
    };
    updateHeader();
    window.addEventListener('scroll', () => {
      if (!scrollFrame) scrollFrame = requestAnimationFrame(updateHeader);
    }, { passive: true });
  }

  const intro = q('[data-intro]');
  if (intro) {
    const wasSeen = !document.documentElement.classList.contains('wr-first-visit');
    if (wasSeen) {
      intro.remove();
    } else {
      const heroVideo = q('[data-home-hero] video');
      if (heroVideo && !heroVideo.paused) heroVideo.pause();
      document.body.classList.add('wr-intro-active');
      requestAnimationFrame(() => intro.classList.add('is-playing'));
      const startedAt = performance.now();
      let hasFinished = false;
      const finishIntro = () => {
        if (hasFinished) return;
        hasFinished = true;
        const minimumDuration = reduced ? 0 : 1550;
        const remaining = Math.max(0, minimumDuration - (performance.now() - startedAt));
        window.setTimeout(() => {
          intro.classList.add('is-loaded');
          window.setTimeout(() => intro.classList.add('is-exiting'), reduced ? 0 : 360);
          window.setTimeout(() => {
            document.body.classList.remove('wr-intro-active');
            intro.remove();
            if (heroVideo) heroVideo.play().catch(() => {});
            window.dispatchEvent(new CustomEvent('wr:intro-complete'));
          }, reduced ? 20 : 1120);
        }, remaining);
      };
      if (document.readyState === 'complete') finishIntro();
      else window.addEventListener('load', finishIntro, { once: true });
      window.setTimeout(finishIntro, reduced ? 40 : 4800);
    }
  }

  document.documentElement.classList.add('wr-enter');
  window.setTimeout(() => document.documentElement.classList.remove('wr-enter'), 1200);

  if (!reduced && document.body.dataset.smoothScroll === 'true' && matchMedia('(min-width: 960px)').matches && !document.body.classList.contains('template-product')) {
    document.documentElement.classList.add('wr-inertial-scroll');
    let smoothTarget = window.scrollY;
    let smoothCurrent = window.scrollY;
    let smoothFrame = 0;
    const maxScroll = () => Math.max(0, document.documentElement.scrollHeight - innerHeight);
    const renderSmoothScroll = () => {
      if (document.documentElement.classList.contains('wr-reel-scroll-locked')) {
        smoothCurrent = window.scrollY;
        smoothTarget = smoothCurrent;
        smoothFrame = 0;
        return;
      }
      smoothCurrent += (smoothTarget - smoothCurrent) * .105;
      if (Math.abs(smoothTarget - smoothCurrent) < .35) {
        smoothCurrent = smoothTarget;
        window.scrollTo(0, smoothCurrent);
        smoothFrame = 0;
        return;
      }
      window.scrollTo(0, smoothCurrent);
      smoothFrame = requestAnimationFrame(renderSmoothScroll);
    };
    window.addEventListener('wheel', (event) => {
      if (event.defaultPrevented || event.ctrlKey || event.metaKey || document.body.classList.contains('is-locked') || event.target.closest('.wr-drawer,.wr-buy-detail__panel,[data-scroll-native],textarea,input[type="number"]')) return;
      event.preventDefault();
      smoothCurrent = window.scrollY;
      if (!smoothFrame) smoothTarget = smoothCurrent;
      smoothTarget = Math.max(0, Math.min(maxScroll(), smoothTarget + event.deltaY * .86));
      if (!smoothFrame) smoothFrame = requestAnimationFrame(renderSmoothScroll);
    }, { passive: false });
    window.addEventListener('resize', () => { smoothTarget = Math.min(smoothTarget, maxScroll()); }, { passive: true });
  }

  if (!reduced && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: .08 });
    const revealTargets = [];
    qa('.shopify-section').forEach((sectionElement) => {
      const revealTarget = sectionElement.firstElementChild;
      if (!revealTarget || revealTarget.matches('.wr-header-wrap,.wr-overlay,.wr-drawer,.wr-footer') || sectionElement.closest('header,footer')) return;
      revealTarget.classList.add('wr-reveal-section');
      revealTargets.push(revealTarget);
      if (revealTargets.length === 1 || revealTarget.getBoundingClientRect().top < innerHeight * .92) revealTarget.classList.add('is-visible');
      else revealObserver.observe(revealTarget);
    });
    // The incoming page is translated from below. IntersectionObserver can
    // otherwise miss its first section until the user nudges the scroll.
    const revealViewportSections = () => revealTargets.forEach((target) => {
      const rect = target.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < innerHeight * .98) target.classList.add('is-visible');
    });
    window.setTimeout(revealViewportSections, 40);
    window.setTimeout(revealViewportSections, 520);
    window.setTimeout(revealViewportSections, 1050);
    window.addEventListener('pageshow', revealViewportSections, { once:true });
  }

  if (!reduced && document.body.dataset.pageTransition === 'true') {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented || link.target || link.hasAttribute('download') || link.origin !== location.origin || (link.hash && link.pathname === location.pathname) || link.href.includes('/checkout')) return;
      event.preventDefault();
      try { sessionStorage.setItem('wr-page-enter', '1'); } catch (error) {}
      const pageShell = document.querySelector('[data-page-shell]');
      if (pageShell) {
        const shellRect = pageShell.getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = window.innerHeight;
        pageShell.style.setProperty('--wr-page-leave-origin-x', `${viewportWidth / 2 - shellRect.left}px`);
        pageShell.style.setProperty('--wr-page-leave-origin-y', `${viewportHeight / 2 - shellRect.top}px`);
        pageShell.style.setProperty('--wr-page-leave-clip-top', `${Math.max(0, -shellRect.top)}px`);
        pageShell.style.setProperty('--wr-page-leave-clip-right', `${Math.max(0, shellRect.right - viewportWidth)}px`);
        pageShell.style.setProperty('--wr-page-leave-clip-bottom', `${Math.max(0, shellRect.bottom - viewportHeight)}px`);
        pageShell.style.setProperty('--wr-page-leave-clip-left', `${Math.max(0, -shellRect.left)}px`);
      }
      document.documentElement.classList.add('wr-page-leave');
      window.setTimeout(() => { location.href = link.href; }, reduced ? 0 : 720);
    });
  }

  function closeDrawers(restoreFocus = true) {
    if (drawerOpenTimer) window.clearTimeout(drawerOpenTimer);
    if (drawerOpenFrame) window.cancelAnimationFrame(drawerOpenFrame);
    drawerOpenTimer = 0;
    drawerOpenFrame = 0;
    pendingDrawerName = null;
    qa('[data-drawer]').forEach((drawerElement) => {
      const wasActive = drawerElement.classList.contains('is-open') || drawerElement.classList.contains('is-preparing');
      drawerElement.classList.remove('is-open', 'is-preparing');
      drawerElement.setAttribute('aria-hidden', 'true');
      hideDrawerAfterClose(drawerElement, wasActive);
    });
    qa('[data-drawer-open]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-label', trigger.dataset.drawerLabelOpen || 'Paneli aç');
    });
    overlay?.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    document.body.removeAttribute('data-open-drawer');
    if (restoreFocus && lastDrawerTrigger) lastDrawerTrigger.focus({ preventScroll: true });
    lastDrawerTrigger = null;
  }

  function openDrawer(name, trigger = null) {
    const drawerElement = q('[data-drawer="' + name + '"]');
    if (!drawerElement) return;
    if (drawerElement.classList.contains('is-open') || pendingDrawerName === name) {
      closeDrawers();
      return;
    }
    closeDrawers(false);
    lastDrawerTrigger = trigger;
    headerWrap?.classList.remove('is-hidden');
    if (window.scrollY > 18) headerWrap?.classList.add('is-returned');
    document.body.classList.add('is-locked');
    document.body.dataset.openDrawer = name;
    overlay?.classList.add('is-open');
    const activeTrigger = trigger || q('[data-drawer-open="' + name + '"]');
    activeTrigger?.setAttribute('aria-expanded', 'true');
    activeTrigger?.setAttribute('aria-label', activeTrigger.dataset.drawerLabelClose || 'Paneli kapat');
    pendingDrawerName = name;
    const panelDelay = reduced ? 0 : 90;
    drawerOpenTimer = window.setTimeout(() => {
      if (pendingDrawerName !== name) return;
      drawerOpenTimer = 0;
      cancelDrawerHide(drawerElement);
      drawerElement.hidden = false;
      drawerElement.classList.add('is-preparing');
      drawerElement.getBoundingClientRect();
      drawerOpenFrame = window.requestAnimationFrame(() => {
        drawerOpenFrame = window.requestAnimationFrame(() => {
          if (pendingDrawerName !== name) {
            drawerElement.classList.remove('is-preparing');
            return;
          }
          pendingDrawerName = null;
          drawerOpenFrame = 0;
          drawerElement.classList.add('is-open');
          drawerElement.classList.remove('is-preparing');
          drawerElement.setAttribute('aria-hidden', 'false');
          activeTrigger?.setAttribute('aria-expanded', 'true');
          overlay?.classList.add('is-open');
          window.setTimeout(() => {
            if (drawerElement.classList.contains('is-open')) q('button, a, input', drawerElement)?.focus({ preventScroll: true });
          }, reduced ? 0 : 260);
        });
      });
    }, panelDelay);
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      const hoverOpenedAt = Number(opener.dataset.wrHoverOpenedAt || 0);
      if (hoverOpenedAt && Date.now() - hoverOpenedAt < 520 && document.body.dataset.openDrawer === opener.dataset.drawerOpen) {
        delete opener.dataset.wrHoverOpenedAt;
        return;
      }
      delete opener.dataset.wrHoverOpenedAt;
      openDrawer(opener.dataset.drawerOpen, opener);
      return;
    }
    if (event.target.closest('[data-drawer-close]') || event.target === overlay) {
      event.preventDefault();
      closeDrawers();
      return;
    }

    const panelButton = event.target.closest('[data-panel-target]');
    if (panelButton) {
      const panel = q('#' + panelButton.dataset.panelTarget);
      const willOpen = !panel?.classList.contains('is-open');
      qa('.wr-side-panel.is-open').forEach((openPanel) => openPanel.classList.remove('is-open'));
      qa('[data-panel-target][aria-expanded="true"]').forEach((openButton) => openButton.setAttribute('aria-expanded', 'false'));
      if (willOpen) panel?.classList.add('is-open');
      panelButton.setAttribute('aria-expanded', String(willOpen));
    }

    const buyPanelButton = event.target.closest('[data-buy-panel-target]');
    if (buyPanelButton) {
      const panel = q('#' + buyPanelButton.dataset.buyPanelTarget);
      const willOpen = !panel?.classList.contains('is-open');
      qa('.wr-buy-detail__panel.is-open').forEach((openPanel) => openPanel.classList.remove('is-open'));
      qa('[data-buy-panel-target][aria-expanded="true"]').forEach((openButton) => openButton.setAttribute('aria-expanded', 'false'));
      if (willOpen) panel?.classList.add('is-open');
      buyPanelButton.setAttribute('aria-expanded', String(willOpen));
    }

    const sizePickerToggle = event.target.closest('[data-size-picker-toggle]');
    if (sizePickerToggle) {
      const picker = sizePickerToggle.closest('[data-size-picker]');
      const panel = q('[data-size-picker-panel]', picker);
      const willOpen = !panel?.classList.contains('is-open');
      qa('[data-size-picker].is-open').forEach((openPicker) => openPicker.classList.remove('is-open'));
      qa('[data-size-picker-panel].is-open').forEach((openPanel) => openPanel.classList.remove('is-open'));
      qa('[data-size-picker-toggle][aria-expanded="true"]').forEach((openButton) => openButton.setAttribute('aria-expanded', 'false'));
      picker?.classList.toggle('is-open', willOpen);
      panel?.classList.toggle('is-open', willOpen);
      sizePickerToggle.setAttribute('aria-expanded', String(willOpen));
    } else if (!event.target.closest('[data-size-picker]')) {
      qa('[data-size-picker].is-open').forEach((picker) => picker.classList.remove('is-open'));
      qa('[data-size-picker-panel].is-open').forEach((panel) => panel.classList.remove('is-open'));
      qa('[data-size-picker-toggle][aria-expanded="true"]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    }

    const policiesToggle = event.target.closest('[data-footer-policies-toggle]');
    if (policiesToggle) {
      event.preventDefault();
      const policies = policiesToggle.closest('[data-footer-policies]');
      const willOpen = !policies?.classList.contains('is-open');
      qa('[data-footer-policies].is-open').forEach((openPolicies) => openPolicies.classList.remove('is-open'));
      qa('[data-footer-policies-toggle][aria-expanded="true"]').forEach((openButton) => openButton.setAttribute('aria-expanded', 'false'));
      policies?.classList.toggle('is-open', willOpen);
      policiesToggle.setAttribute('aria-expanded', String(willOpen));
    } else if (!event.target.closest('[data-footer-policies]')) {
      qa('[data-footer-policies].is-open').forEach((policies) => policies.classList.remove('is-open'));
      qa('[data-footer-policies-toggle][aria-expanded="true"]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (q('[data-drawer].is-open')) closeDrawers();
    qa('.wr-side-panel.is-open,.wr-buy-detail__panel.is-open').forEach((panel) => panel.classList.remove('is-open'));
    qa('[data-size-picker].is-open').forEach((picker) => picker.classList.remove('is-open'));
    qa('[data-size-picker-panel].is-open').forEach((panel) => panel.classList.remove('is-open'));
    qa('[data-footer-policies].is-open').forEach((policies) => policies.classList.remove('is-open'));
    qa('[data-panel-target][aria-expanded="true"],[data-buy-panel-target][aria-expanded="true"],[data-size-picker-toggle][aria-expanded="true"]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    qa('[data-footer-policies-toggle][aria-expanded="true"]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
  });

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '₺';
  }

  function animatePriceRoll(element, toCents) {
    if (!element) return;
    const newText = formatMoney(toCents);
    const oldText = element.dataset.rollTarget || element.textContent.trim();
    if (oldText === newText && element.dataset.rolling === '1') return;
    if (reduced || oldText === newText) {
      element.textContent = newText;
      element.classList.remove('wr-price-roll', 'is-rolling');
      delete element.dataset.rolling;
      delete element.dataset.rollTarget;
      return;
    }
    if (element._wrRollTimer) window.clearTimeout(element._wrRollTimer);
    const width = Math.max(oldText.length, newText.length);
    const oldChars = oldText.padStart(width, ' ').split('');
    const newChars = newText.padStart(width, ' ').split('');
    element.dataset.rolling = '1';
    element.dataset.rollTarget = newText;
    element.classList.add('wr-price-roll');
    element.innerHTML = newChars.map((character, index) => {
      const changed = oldChars[index] !== character;
      return '<span class="wr-price-slot' + (changed ? ' is-changing' : '') + '" style="--slot-i:' + index + '"><span class="wr-price-slot__old">' + (oldChars[index] === ' ' ? '&nbsp;' : oldChars[index]) + '</span><span class="wr-price-slot__new">' + (character === ' ' ? '&nbsp;' : character) + '</span></span>';
    }).join('');
    element.classList.remove('is-rolling');
    // Force the starting cylinder position to paint before rolling. Without
    // this flush the first cart update can collapse both states into one frame.
    void element.offsetWidth;
    requestAnimationFrame(() => requestAnimationFrame(() => element.classList.add('is-rolling')));
    element._wrRollTimer = window.setTimeout(() => {
      element.textContent = newText;
      element.classList.remove('wr-price-roll', 'is-rolling');
      delete element.dataset.rolling;
      delete element.dataset.rollTarget;
      delete element._wrRollTimer;
    }, 760);
  }

  function cartLineMarkup(item, lineNumber) {
    return '<article class="wr-cart-line" data-cart-line data-line-key="' + item.key + '" data-line-number="' + lineNumber + '">'
      + (item.image ? '<img src="' + item.image + '" alt="" loading="lazy" decoding="async">' : '')
      + '<div><h4>' + item.product_title + '</h4><p>' + (item.variant_title || '') + '</p>'
      + '<div class="wr-cart-line__qty">'
      + '<button type="button" data-qty-decrease aria-label="Adedi azalt">−</button>'
      + '<span data-qty-value>' + item.quantity + '</span>'
      + '<button type="button" data-qty-increase aria-label="Adedi artır">+</button>'
      + '</div></div>'
      + '<div class="wr-cart-line__side">'
      + '<span class="wr-price" data-line-price data-cents="' + item.final_line_price + '">' + formatMoney(item.final_line_price) + '</span>'
      + '<button type="button" class="wr-cart-line__remove" data-qty-remove aria-label="Ürünü sepetten kaldır"><span aria-hidden="true">×</span></button>'
      + '</div></article>';
  }

  function renderCartTotals(cart) {
    qa('[data-cart-count]').forEach((count) => {
      count.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
      count.hidden = cart.item_count === 0;
    });
    qa('[data-cart-page-count]').forEach((count) => { count.textContent = cart.item_count + ' ürün'; });
    qa('[data-cart-total]').forEach((total) => {
      total.dataset.cents = String(cart.total_price);
      animatePriceRoll(total, cart.total_price);
    });
    qa('[data-cart-checkout]').forEach((checkout) => {
      const isEmpty = cart.item_count === 0;
      checkout.hidden = isEmpty;
      checkout.setAttribute('aria-hidden', String(isEmpty));
      if (isEmpty) checkout.setAttribute('tabindex', '-1');
      else checkout.removeAttribute('tabindex');
    });
  }

  function renderEmptyCartStates(cart) {
    if (cart.items.length) return;
    qa('[data-cart-lines]').forEach((list) => { list.innerHTML = '<p class="wr-empty">Sepetiniz boş.</p>'; });
    qa('.wr-cart-page__layout').forEach((layout) => {
      layout.outerHTML = '<div class="wr-cart-empty"><h2>Sepetiniz henüz boş</h2><p>Yeni koleksiyonu keşfedin ve size ait parçaları seçin.</p><a class="wr-button" href="/collections/all">Alışverişe devam et</a></div>';
    });
  }

  async function cartRefresh(shouldOpen = false) {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart refresh failed');
    const cart = await response.json();
    renderCartTotals(cart);
    qa('[data-cart-lines]').forEach((list) => {
      list.innerHTML = cart.items.length ? cart.items.map((item, index) => cartLineMarkup(item, index + 1)).join('') : '<p class="wr-empty">Sepetiniz boş.</p>';
    });
    renderEmptyCartStates(cart);
    if (shouldOpen) openDrawer('cart');
    return cart;
  }

  async function cartChange(identifier, quantity) {
    const payload = JSON.stringify(typeof identifier === 'number' ? { line: identifier, quantity } : { id: identifier, quantity });
    for (let attempt = 0; attempt < 2; attempt += 1) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: payload,
      });
      if (response.ok) return response.json();
      if (attempt === 0) await new Promise((resolve) => window.setTimeout(resolve, 140));
    }
    throw new Error('Cart change failed');
  }

  async function removeCartLine(line, key, lineNumber) {
    const matchingLines = qa('[data-cart-line]').filter((item) => item.dataset.lineKey === key || Number(item.dataset.lineNumber) === lineNumber);
    matchingLines.forEach((item) => item.classList.add('is-updating', 'is-remove-pending'));
    try {
      // The cart line key remains stable even when another line was removed, so
      // prefer it over the positional line number for drawer and cart-page parity.
      const cart = await cartChange(key || lineNumber, 0);
      if (!cart || !Array.isArray(cart.items)) {
        throw new Error('Malformed cart response');
      }
      matchingLines.forEach((item) => item.classList.replace('is-remove-pending', 'is-removing'));
      renderCartTotals(cart);
      window.setTimeout(() => {
        matchingLines.forEach((item) => item.remove());
        qa('[data-cart-line]').forEach((item) => {
          const currentLineNumber = Number(item.dataset.lineNumber);
          if (currentLineNumber > lineNumber) item.dataset.lineNumber = String(currentLineNumber - 1);
        });
        renderEmptyCartStates(cart);
      }, reduced ? 0 : 380);
    } catch (error) {
      matchingLines.forEach((item) => item.classList.remove('is-updating', 'is-remove-pending', 'is-removing'));
      await cartRefresh();
    }
  }

  document.addEventListener('click', async (event) => {
    const decreaseButton = event.target.closest('[data-qty-decrease]');
    const increaseButton = event.target.closest('[data-qty-increase]');
    const removeButton = event.target.closest('[data-qty-remove]');
    if (!decreaseButton && !increaseButton && !removeButton) return;
    event.preventDefault();
    const line = (decreaseButton || increaseButton || removeButton).closest('[data-cart-line]');
    if (!line || line.classList.contains('is-updating')) return;
    const key = line.dataset.lineKey;
    const lineNumber = Number(line.dataset.lineNumber || 0);

    if (removeButton) {
      await removeCartLine(line, key, lineNumber);
      return;
    }

    const qtyValue = q('[data-qty-value]', line);
    const currentQuantity = Number(qtyValue?.textContent || 1);
    const nextQuantity = currentQuantity + (increaseButton ? 1 : -1);
    if (nextQuantity <= 0) {
      await removeCartLine(line, key, lineNumber);
      return;
    }

    line.classList.add('is-updating');
    try {
      const cart = await cartChange(lineNumber || key, nextQuantity);
      if (!cart || !Array.isArray(cart.items)) {
        // Malformed/error response: resync from server truth rather than leaving the UI stuck.
        await cartRefresh();
        return;
      }
      const updatedItem = lineNumber ? cart.items[lineNumber - 1] : cart.items.find((item) => item.key === key);
      if (!updatedItem) {
        await cartRefresh();
        return;
      }
      qa('[data-cart-line]').filter((item) => Number(item.dataset.lineNumber) === lineNumber || item.dataset.lineKey === key).forEach((matchingLine) => {
        matchingLine.dataset.lineKey = updatedItem.key;
        const matchingQty = q('[data-qty-value]', matchingLine);
        const matchingPrice = q('[data-line-price]', matchingLine);
        if (matchingQty) matchingQty.textContent = updatedItem.quantity;
        if (matchingPrice) {
          matchingPrice.dataset.cents = String(updatedItem.final_line_price);
          animatePriceRoll(matchingPrice, updatedItem.final_line_price);
        }
      });
      renderCartTotals(cart);
    } catch (error) {
      await cartRefresh();
    } finally {
      line.classList.remove('is-updating');
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-quick-add]');
    if (!button) return;
    event.preventDefault();
    button.disabled = true;
    try {
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }) });
      await cartRefresh(true);
    } finally {
      button.disabled = false;
    }
  });

  qa('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    if (event.submitter?.name === 'checkout') return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    try {
      await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      await cartRefresh(true);
    } finally {
      if (button) button.disabled = false;
    }
  }));

  qa('[data-product-gallery]').forEach((gallery) => {
    const images = qa('img', gallery);
    const bars = qa('.wr-gallery-progress i', gallery);
    const progress = q('.wr-gallery-progress', gallery);
    if (!images.length) return;
    let active = 0;
    const show = (index) => {
      index = Math.max(0, Math.min(images.length - 1, index));
      if (index === active) return;
      bars[active]?.classList.remove('is-active');
      active = index;
      images.forEach((image, imageIndex) => {
        image.classList.toggle('is-active', imageIndex === active);
      });
      bars[active]?.classList.add('is-active');
      gallery.dataset.galleryIndex = String(active);
    };
    gallery.dataset.galleryIndex = '0';
    if (innerWidth >= 960) {
      let galleryFrame = 0;
      const updateStackedGallery = () => {
        const galleryRect = gallery.getBoundingClientRect();
        const galleryTop = galleryRect.top + window.scrollY;
        const index = Math.floor((window.scrollY + innerHeight * .5 - galleryTop) / innerHeight);
        show(index);
        progress?.classList.toggle('is-gallery-visible', galleryRect.top < innerHeight && galleryRect.bottom > 0);
        document.body.classList.toggle('wr-product-first-media', active === 0);
        galleryFrame = 0;
      };
      updateStackedGallery();
      window.addEventListener('scroll', () => {
        if (!galleryFrame) galleryFrame = requestAnimationFrame(updateStackedGallery);
      }, { passive: true });
      window.addEventListener('resize', updateStackedGallery, { passive: true });
      return;
    }
    if (images.length < 2) return;
    gallery.addEventListener('click', (event) => {
      if (event.target.closest('button,a')) return;
      const rect = gallery.getBoundingClientRect();
      show(event.clientX - rect.left < rect.width / 2 ? active - 1 : active + 1);
    });
    gallery.addEventListener('touchend', (event) => {
      if (event.target.closest('button,a')) return;
      const rect = gallery.getBoundingClientRect();
      show(event.changedTouches[0].clientX - rect.left < rect.width / 2 ? active - 1 : active + 1);
    }, { passive: true });
  });

  qa('[data-variant-input]').forEach((input) => input.addEventListener('change', () => {
    const form = input.closest('form');
    const hidden = q('[name="id"]', form);
    if (hidden) hidden.value = input.value;
    const productSection = input.closest('.wr-product');
    const price = q('[data-current-price]', productSection);
    const comparePrice = q('[data-compare-price]', productSection);
    const discountBadge = q('[data-discount]', productSection);
    if (price && input.dataset.price) price.textContent = input.dataset.price;
    if (comparePrice) {
      comparePrice.textContent = input.dataset.comparePrice || '';
      comparePrice.hidden = !input.dataset.comparePrice;
    }
    if (discountBadge) {
      const discount = Number(input.dataset.discount || 0);
      discountBadge.textContent = discount > 0 ? 'İNDİRİM -%' + discount : '';
      discountBadge.hidden = discount === 0;
    }
    const picker = input.closest('[data-size-picker]');
    picker?.classList.remove('is-open');
    const selectedSize = q('[data-selected-size]', picker);
    if (selectedSize) selectedSize.textContent = input.nextElementSibling?.textContent?.trim() || '';
    q('[data-size-picker-panel]', picker)?.classList.remove('is-open');
    q('[data-size-picker-toggle]', picker)?.setAttribute('aria-expanded', 'false');
  }));

  qa('[data-rec-track]').forEach((track) => {
    if (reduced) return;
    const seconds = Number(track.dataset.autoplay || 0);
    if (!seconds) return;
    window.setInterval(() => {
      const card = track.firstElementChild;
      if (!card) return;
      const step = card.getBoundingClientRect().width + 24;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: 'smooth' });
    }, seconds * 1000);
  });
})();
